<template>
  <div class="playback-area">
    <div class="aisea-text-16-400-black">指定範囲：{{ specifyAreaText }}</div>
  </div>
</template>

<script>
import isObject from "lodash/isObject";
export default {
  name: "PlaybackArea",
  props: {
    playbackRequestSettings: {
      type: Object, // playbackRequestSettings
      default() {
        return {};
      },
    },
  },
  computed: {
    isSpecifyAreaValid() {
      const { playbackRequestSettings: requestSettings } = this;
      if (!isObject(requestSettings)) return false;
      if (!requestSettings.isAreaValid) return false;
      return requestSettings.isAreaValid();
    },
    specifyAreaHeight() {
      if (!this.isSpecifyAreaValid) return null;
      return this.playbackRequestSettings.calcHeight();
    },
    specifyAreaWidth() {
      if (!this.isSpecifyAreaValid) return null;
      return this.playbackRequestSettings.calcWidth();
    },
    specifyAreaText() {
      if (!this.isSpecifyAreaValid) return "";
      // e.g.: 指定範囲：2.0nm x 1.0nm
      return `${this.truncateAreaDistance(
        this.specifyAreaHeight
      )}nm x ${this.truncateAreaDistance(this.specifyAreaWidth)}nm`;
    },
  },
  methods: {
    truncateAreaDistance(
      distance // number
    ) {
      return (Math.trunc(distance * 10) / 10).toFixed(1);
    },
  },
};
</script>
